export type ShareOutcome = 'shared' | 'copied' | 'failed';

/** Native share sheet where supported (mobile), otherwise clipboard (PRD §4.4, §10). */
export async function shareText(text: string): Promise<ShareOutcome> {
  if (typeof navigator.share === 'function' && navigator.canShare?.({ text }) !== false) {
    try {
      await navigator.share({ text });
      return 'shared';
    } catch (err) {
      if (err instanceof DOMException && err.name === 'AbortError') return 'failed';
      // Fall through to the clipboard.
    }
  }
  try {
    await navigator.clipboard.writeText(text);
    return 'copied';
  } catch {
    return 'failed';
  }
}
